import { Box, Flex, Image, useBreakpointValue } from "@chakra-ui/react";
import courseBg from "@/assets/images/course_banner.png";
import courseImg from "@/assets/images/courseimg.png";

const MyCourse = () => {
  const fontSize1 = useBreakpointValue({
    base: '14px', 
    md: '18px', 
    lg: '22px',  
  });
  
  return (
    <Box overflow={"hidden"}>
      <Box width="80%" m="0 auto">
        <Box
          mt="40px"
          mb="20px"
          color="#27314D"
          fontWeight="bold"
          fontSize="24px"
        >
          我的课程
        </Box>
        <Flex
          h="149px"
          position={"relative"}
          bg={`url('${courseBg}')`}
          backgroundSize="cover"
          backgroundPosition="top center"
          bgRepeat={"no-repeat"}
          alignItems="center"
        >
          <Box w="60%" p="20px" color={"#27314D"} fontSize={fontSize1}>我的课程是「AIGC+建筑装饰设计」在线教育板块，提供专业技能培训服务，更有AIGC设计提效实战，敬请期待。</Box>
        </Flex>
        <Box mt="40px" color={"#27314D"} fontSize="18px" fontWeight={"bold"}>
          部分效果预展示
        </Box>
        <Flex mt="35px" mb="60px" justifyContent={"center"}>
          <Image src={courseImg} />
        </Flex>
      </Box>
    </Box>
  );
};

export default MyCourse;
